import { useMemo } from "react";
import { PriceModes } from "@components/molecules/PriceModeCard/types";

interface UsePdpPricingProps {
  route: any;
  userInfo: any;
}

export const usePdpPricing = ({ route, userInfo }: UsePdpPricingProps) => {
  const priceMode = useMemo(() => {
    return route?.params?.externalPriceMode === undefined
      ? userInfo.getUserPriceMode()
      : route?.params?.externalPriceMode;
  }, [route?.params?.externalPriceMode, userInfo?.getUserPriceMode()]);

  const priceMarkup = useMemo(() => {
    return userInfo.getUserPriceMode() === PriceModes.ORANGE
      ? userInfo.getUserMarkupAmount()
      : 0;
  }, [userInfo?.getUserPriceMode(), userInfo?.getUserMarkupAmount()]);

  return {
    priceMode,
    priceMarkup,
  };
};
